export const DECIMAL_NUMBER_INPUT_REGEX = /[\d.-]/;
export const phoneRegex = /^\s*([+]977\d{10}|[+]61\d{9,10})\s*$/;
export const HEIC_HEIF_REGEX = /\.(heic|heif)$/i;
export const PHONE_REGEX = /^\s*([+]977\d{10}|[+]61\d{9,10})\s*$/;
export const COMMA_REGEX = /,/g;

export const DATE_FORMATS_REGEX = {
  YYYY_MM_DD: /^\d{4}-\d{2}-\d{2}$/,
} as const;
export const HEX_COLOR_6_DIGIT_REGEX = /^[0-9A-Fa-f]{6}$/;
export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
